import React, { Component } from "react";
import { Popover, Form, Button, Icon, Table, Modal, Input, message, Select, Checkbox, InputNumber } from "antd";
import { getCheckChildTypeList, addCheckProject, editCheckProject, deleteCheckProject, getCheckProjectList } from '@/request/api'
import './components.scss'
import { requestErrorLog } from '@/common/util'

const { confirm } = Modal;
const { TextArea } = Input;
const { Option } = Select;
class SettingDepartment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tableList: [],
      checkTypeList: [],
      pageNo: 1,
      pageSize: 10,
      rowCount: 0,
      className: '',
      textareaText: '',
      departmentColumns: [
        {
          title: "项目编码",
          dataIndex: "ITEM_CODE",
          key: "ITEM_CODE",
          width: 300,
        },
        {
          title: "项目名称",
          dataIndex: "ITEM_NAME",
          key: "ITEM_NAME",
          width: 170,
        },
        {
          title: "备注",
          dataIndex: "REMARKS",
          key: "REMARKS",
          width: 300,
          ellipsis: true,
          render: (text) => {
            return (
              <Popover
                placement="topLeft"
                overlayStyle={{ width: "300px" }}
                content={<span style={{ color: "#333" }}>{text}</span>}
              >
                <span>{text}</span>
              </Popover>
            );
          },
        },
      ],
      parentCode: '',
      printTempData: ['向量图', '晚电位', '高频心电', '频谱心电', '心率变异', 'QT', '心率震荡', '心率加减速', 'T波电交替', '阿托品',]
    }
  }

  componentDidMount() {
    this.getTableList()
    this.getCheckedTypeList()
  }

  getTableList = () => {
    let params = {
      pageNo: this.state.pageNo,
      pageSize: this.state.pageSize,
      NAME: this.state.className
    }
    getCheckProjectList(params).then(res => {
      if (res && res.Status === 1) {
        this.setState({
          tableList: res.Result.dataList,
          rowCount: res.Result.rowCount,
          rowData: null,
        })
      }else{
        requestErrorLog('', '系统设置-检查项目-获取检查项目列表报错', 0, true)
      }
    })
  }

  getCheckedTypeList = () => {  //获取检查子类的列表
    let params = {
      pageNo: 1,
      pageSize: 40,
      NAME: ''
    }
    getCheckChildTypeList(params).then(res => {
      if (res && res.Status === 1) {
        this.setState({
          checkTypeList: res.Result.dataList
        })
      }else{
        requestErrorLog('', '系统设置-检查项目-获取检查子类列表报错', 0, true)
      }
    })
  }

  handleProjectAdd = () => {// 新增
    this.props.form.resetFields();
    this.setState({
      isModalVisible: true,
      modalTitle: 'add',
      parentCode: '',
      rowData: {
        CLASS_CODE: "",
        CLASS_NAME: "",
      }
    })
  }

  handleProjectEdit = () => { // 修改
    const { rowData } = this.state
    this.props.form.resetFields();
    if (rowData) {
      if (rowData.PRINT_TEMPLATE && !Array.isArray(rowData.PRINT_TEMPLATE)) {
        rowData.PRINT_TEMPLATE = rowData.PRINT_TEMPLATE.split(',')
      }
      this.setState({
        editModalVisible: true,
        modalTitle: 'edit',
      })
    } else {
      message.warning('请先选择要操作的数据');
    }
  }

  handleProjectDelete = () => { // 删除
    const { rowData } = this.state
    if (rowData) {
      rowData.PRINT_TEMPLATE = rowData.PRINT_TEMPLATE?.toString()
      confirm({
        title: '删除操作',
        content: '确认删除该类型吗？',
        onOk: () => {
          deleteCheckProject(rowData).then(res => {
            if (res && res.Status === 1) {
              message.success('删除成功')
              this.getTableList()
            } else {
              requestErrorLog('', '系统设置-检查项目-获取检查项目列表报错', 0, true)
              message.error('删除失败')
            }
          })
        },
      });
    } else {
      message.warning('请先选择要操作的数据');
    }
  }

  handleOk = () => {
    const { isModalVisible, editModalVisible, rowData } = this.state
    this.props.form.validateFields((err, values) => {
      if (!err) {
        if (isModalVisible === true) {
          const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
          let params = {
            ITEM_NAME: values.ITEM_NAME,
            PARENT_CODE: values.PARENT_CODE,
            REMARKS: values.REMARKS,
            PRINT_TEMPLATE: values.PRINT_TEMPLATE?.toString(),
            SAMPLE_TIME: values.SAMPLE_TIME
          }
          addCheckProject(userInfo.HOSPITAL_CODE, params).then(res => {
            if (res && res.Status === 1) {
              if (res.Result === '2') {
                message.error('类型名称不能重复')
                return
              }
              message.success('添加成功')
              this.getTableList()
            } else {
              requestErrorLog('', '系统设置-检查项目-添加项目报错', 0, true)
              message.error('添加失败')
            }
            this.setState({
              isModalVisible: false
            })
          })
        }
        if (editModalVisible === true) {
          let params = {
            EXAM_ITEM_UID: rowData.EXAM_ITEM_UID,
            ITEM_CODE: rowData.ITEM_CODE,
            ITEM_NAME: values.ITEM_NAME,
            PARENT_CODE: values.PARENT_CODE,
            PRINT_TEMPLATE: values.PRINT_TEMPLATE?.toString(),
            REMARKS: values.REMARKS,
            SAMPLE_TIME: values.SAMPLE_TIME
          }
          editCheckProject(params).then(res => {
            if (res && res.Status === 1) {
              if (res.Result === '2') {
                message.error('类型名称不能重复')
                return
              }
              message.success('编辑成功')
              this.getTableList()
            } else {
              requestErrorLog('', '系统设置-检查项目-编辑项目报错', 0, true)
              message.error('编辑失败')
            }
            this.setState({
              editModalVisible: false,
            })
          })
        }
      }
    })
  }

  onClickRow = (record) => {
    this.setState({
      rowData: record,
      parentCode: record.EXAM_CLASS
    });
  }

  setRowClassName = (record) => {
    return record === this.state.rowData ? 'clickRowStyl' : '';
  }

  handleCancel = () => {
    this.setState({
      isModalVisible: false,
      editModalVisible: false
    })
  }

  classNameChange = e => {
    this.setState({
      className: e.target.value,
    })
  }

  handleCheckTypeList = () => {
    this.setState({
      PageNo: 1,
      PageSize: 10
    }, () => {
      this.getTableList()
    })
  }
  changeFocus = e => {
    if (e.keyCode === 13) {
      this.handleCheckTypeList();
    }
  }
  changePageFn = (pageNo) => {
    this.setState({
      pageNo
    }, () => {
      this.getTableList()
    })
  }

  changeSubClass = (value, option) => {
    this.setState({
      parentCode: option.key
    })
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const { isModalVisible, editModalVisible, modalTitle, departmentColumns, tableList, rowData, checkTypeList, parentCode, printTempData } = this.state;
    return (
      <div>
        <div className="btnStyle" style={{ marginBottom: "10px" }}>
          <Button onClick={this.handleProjectAdd}>
            <Icon type="plus-circle" />
            添加
          </Button>
          <Button onClick={this.handleProjectEdit}>
            <Icon type="minus-circle" />
            修改
          </Button>
          <Button onClick={this.handleProjectDelete}>
            <Icon type="close-circle" />
            删除
          </Button>
        </div>
        <Form layout="inline" className="searchBox">
          <Form.Item label="项目名称">
            <Input allowClear value={this.state.className} onChange={this.classNameChange} onKeyUp={this.changeFocus} />
          </Form.Item>
          <Button onClick={this.handleCheckTypeList}>查询</Button>
        </Form>
        <Table
          columns={departmentColumns}
          dataSource={tableList}
          rowKey={(record) => record.ITEM_CODE}
          bordered
          pagination={{
            total: this.state.rowCount,
            current: this.state.pageNo,
            onChange: this.changePageFn
          }}
          onRow={(record) => {
            return {
              onClick: (e) => {
                this.onClickRow(record);
              }, //点击行
            }
          }
          }
          rowClassName={this.setRowClassName}
        />
        {isModalVisible || editModalVisible ?
          <Modal
            title={
              <div className="patient_title">
                <img alt="" src={require("@/assets/image/ecg.png").default} className="addIcon" />
                <span>{modalTitle === "add" ? "添加检查项目" : "编辑检查项目"}</span>
              </div>
            }
            visible={isModalVisible || editModalVisible}
            maskClosable={false}
            onOk={this.handleOk}
            onCancel={this.handleCancel}
          >
            <Form layout="inline" className="settingFormBox">
              <Form.Item label="检查子类" className="settingHospitalAddr">
                {getFieldDecorator('PARENT_CODE', { initialValue: rowData && rowData.PARENT_CODE ? rowData.PARENT_CODE : '', rules: [{ required: true, message: '请选择检查类型' }] })(
                  <Select onChange={this.changeSubClass}>
                    {checkTypeList.map(item => (
                      <Option key={item.PARENT_CODE} value={item.SUB_CLASS_CODE} >{item.SUB_CLASS_NAME}</Option>
                    ))}
                  </Select>
                )}
              </Form.Item>

              <Form.Item label="项目名称" className="settingHospitalAddr">
                {getFieldDecorator('ITEM_NAME', { initialValue: rowData && rowData.ITEM_NAME ? rowData.ITEM_NAME : '', rules: [{ required: true, message: '请输入类型名称' }] })(<Input allowClear={true} />)}
              </Form.Item>

              {parentCode === 'ECG' ?
                <Form.Item label="打印默认项">
                  {getFieldDecorator('PRINT_TEMPLATE', { initialValue: rowData && rowData.PRINT_TEMPLATE ? rowData.PRINT_TEMPLATE : [] })(
                    <Checkbox.Group
                      style={{ marginTop: '10px' }}
                      // onChange={this.printTemplateChange}
                      options={printTempData}
                    >
                    </Checkbox.Group>
                  )}
                </Form.Item> : null}
              {parentCode === 'ECG' ?
                <Form.Item label="默认采集时长">
                  {getFieldDecorator('SAMPLE_TIME', { initialValue: rowData && rowData.SAMPLE_TIME ? rowData.SAMPLE_TIME : 10, rules: [{ required: true, message: '请输入默认采集时长' }] })(
                    <InputNumber min={10} max={3600} />
                  )} 秒
                </Form.Item> : null}
              <Form.Item label="备&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;注" className="settingHospitalAddr">
                {getFieldDecorator('REMARKS', { initialValue: rowData && rowData.REMARKS ? rowData.REMARKS : '' })(<TextArea rows={5} />)}
              </Form.Item>
            </Form>
          </Modal> : null
        }

      </div>
    );
  }
}

export default (Form.create({})(SettingDepartment));
